module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/myKrCt/tc-custom/scover.jpg?1685327318653?1692044794258",
      "alt": "This image is the cover for the book Caged"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Caged\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("Jared thinks life in his big cat refuge is perfect. Surrounded by tigers, lions, leopards, and cougars, Jared has moved easily from life as a college baseball star. Sultan, his favorite tiger, is healthy and happy; his wife Julianna is the same. Or so he thinks. When Jared suspects that Julianna is getting a little too close to the refuge volunteers, he faces a tough choice.")]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Belea T. Keeney\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Belea T. Keeney was born and raised in the balmy tropics of Florida and still dreams of velvet-humid nights, the smell of orange blossoms, and the croak of alligators. Her writing has appeared in Florida Horror: Dark Tales from the Sunshine State, The Beast Within, Sniplits, Boundoff, WordKnot, along with many other outlets. Her stories have placed in the Writers in Paradise Short Story competition, the 2010 Florida Review Editor's Choice Award, the 2007 Left Coast Writing Contest, and the 2011 Saints & Sinners Literary Festival. She works as an editor and spends her time off collecting caladiums, feeding birds, and, of course, reading. For more information, please visit beleatkeeney.com.")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0